<!--
    描述：电子保函 -> 保费开票申请
    时间：2023-02-09
    Created by zcc
-->
<template>
	<div class="bh-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="doReset" v-if="!routeQuery" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="保费开票申请单位" prop="enterpriseName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.enterpriseName"> </el-input>
					</el-form-item>
					<el-form-item label="统一社会信用代码" prop="creditCode">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.creditCode"> </el-input>
					</el-form-item>
					<el-form-item label="发票代码" prop="invoiceCode">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.invoiceCode"> </el-input>
					</el-form-item>
					<el-form-item label="发票号码" prop="invoiceNumber">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.invoiceNumber"> </el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="130px">
					<el-form-item label="保函编号" prop="guaranteeNumber">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.guaranteeNumber"> </el-input>
					</el-form-item>
					<el-form-item label="申请人" prop="applyUserName">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.applyUserName"> </el-input>
					</el-form-item>
					<el-form-item label="申请时间" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							合计保费开票申请记录：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" size="mini" border>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>
								<el-table-column prop="id" label="业务流水号" align="center" width="180" show-overflow-tooltip> </el-table-column>
								<el-table-column
									prop="guaranteeNumber"
									label="瀚华保函编号"
									align="center"
									width="160"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="invoiceMode" label="发票类型" align="center" width="100" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.invoiceMode == '1'">电子普票</span>
									</template>
								</el-table-column>
								<el-table-column
									prop="enterpriseName"
									label="保费申请单位"
									align="center"
									width="139"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="creditCode"
									label="统一社会信用代码"
									width="180"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="email" label="发票通知邮箱" width="120" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column
									prop="invoiceCode"
									label="发票代码"
									width="120"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="invoiceNumber" label="发票号码" width="100" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column
									prop="applyUserName"
									label="申请人"
									width="100"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="createDate"
									label="申请时间"
									width="150"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="sysSourceName"
									label="业务来源"
									width="80"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="status" label="开票状态" width="100" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										<span v-if="scope.row.status == '0'" class="status-img">
											<img src="../../../../assets/images/between.png" alt="" />
											申请中
										</span>
										<span v-else-if="scope.row.status == '1'" class="status-img">
											<img src="../../../../assets/images/success.png" alt="" />
											已开票
										</span>
										<span v-else-if="scope.row.status == '2'" class="status-img">
											<img src="../../../../assets/images/fail.png" alt="" />
											申请失败
										</span>
									</template>
								</el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<!-- v-if="roleBtns.includes('memberDetail')" -->
									<template slot-scope="scope">
										<el-button type="primary" size="small" round plain class="table-btn" @click="showDetail(scope.row)">
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-sizes="tableObj.pageList"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import memberDetail from './components/detail'
import * as API from 'api/modules/bh/bh-premium-invoicing-application'
export default {
	name: 'bh-premium-invoicing-application-index',
	components: {
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			//会员类型下拉信息
			accountTypeDL: [],
			//证件类型
			certTypeDL: [],

			searchForm: {
				enterpriseName: '', //保费开票申请单位
				creditCode: '', //统一社会信用代码
				invoiceCode: '', //发票代码
				invoiceNumber: '', //发票号码
				guaranteeNumber: '', //保函编号
				applyUserName: '', //申请人
				dateArr: [],
				applyDataStart: null,
				applyDataEnd: null
			},
			tableObj: {
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			}
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getSelectInvoiceList()
	},
	methods: {
		//查询
		doSearch() {
			this.getSelectInvoiceList()
		},
		//获取分页列表信息
		getSelectInvoiceList() {
			this.tableObj.data = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.applyDataStart = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.applyDataEnd = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.applyDataStart = ''
				this.searchForm.applyDataEnd = ''
			}
			let param = Object.assign({}, this.searchForm)
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			API.getSelectInvoiceList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//重置查询
		doReset() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.searchForm.applyDataStart = null
			this.searchForm.applyDataEnd = null
			this.searchForm.dateArr = []
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectInvoiceList()
		},
		//操作-详情
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))
			this.$router.push({
				path: 'bh-premium-invoicing-application-index',
				query: {
					type: 'memberDetail',
					id: row.id
				}
			})
		},
		//刷新
		reFresh() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getSelectInvoiceList()
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getSelectInvoiceList()
		},
		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getSelectInvoiceList()
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},
		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = that.searchForm.applyDataEnd
					if (endTime) {
						return time.getTime() >= new Date(endTime).getTime()
					} else return false
				}
			}
		},
		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = that.searchForm.applyDataStart
					if (startTime) {
						return time.getTime() <= new Date(startTime).getTime()
					} else return false
				}
			}
		},
		// 返回
		goBack() {
			this.$router.push({ path: '/bh-premium-invoicing-application-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.operation-layout.pd0 {
	padding: 0;
}
.bh-main {
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-col {
			height: 48px;
		}

		.text-center {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}

.status-img {
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		margin-right: 5px;
	}
}
</style>
